import { useEffect, useRef, useState } from "react";
import Swap from '../../components/Swap/Swap';

const Wallet = ({}) => {
    return (
        <>
            <Swap />
        </>
    )
};

export default Wallet;